import React from "react";
import Staff1 from "../../image/faculty/staff1.jpg";
import IndicatorIcon from "../../components/IndicatorIcon";
import FlipCard from "../../components/FlipCard";
import Carousel from "react-multi-carousel";
import { FacultyStaffList } from "../../Data";
import PaginationControls from "../../components/PaginationControls";
import { usePagination } from "../../Utils";
function FacultyStaff() {
  const itemsPerPage = 9;

  const {
    currentIndex,
    currentSlide,
    currentItems,
    totalItems,
    handlePrevious,
    handleNext,
    setCurrentPage,
  } = usePagination(FacultyStaffList, itemsPerPage);

  return (
    <section
      id="faculty-staff"
      className=" responsive-padding flex flex-col gap-4 py-10"
    >
      <h1 className=" font-montserrat font-bold text-2xl md:text-3xl laptopSm:text-4xl leading-4 align-middle text-text-dark">
        Faculty and Staff
      </h1>
      <p className=" font-notoSans font leading-6 tracking-[0.06em] laptopSm:tracking-wider text-xs laptopSm:text-base md:text-sm text-grey-normal align-middle">
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent id
        nibh vel massa efficitur fermentum non ac orci. In sed libero vitae eros
        fermentum ultricies.
      </p>
      <div className="hidden md:block">
        <div className="md:grid grid-cols-3 gap-4  ">
          {currentItems.map((item, index) => (
            <div key={index} className="w-full h-[168px]  relative">
              <img
                src={item.image}
                alt={item.image}
                className="w-full h-full object-cover object-center" // Ensure the image takes full height
              />{" "}
              <div
                className="w-full bg-[linear-gradient(90deg,_#000000_8%,_rgba(0,_0,_0,_0.4)_27.5%,_rgba(157,_156,_157,_0.05)_49%,_rgba(217,_217,_217,_0)_69%)]
            absolute bottom-0 left-0 text-white py-2 px-6 "
              >
                <span className="font-bold font-montserrat text-sm leading-6 tracking-[0.06em]">
                  {item.name}{" "}
                </span>{" "}
                <br />
                <span className=" font-medium font-montserrat text-xs leading-6 tracking-[0.06em]">
                  {item.position}{" "}
                </span>
              </div>
            </div>
          ))}
        </div>
        <div className="w-1/2 m-auto mt-10">
          {" "}
          <PaginationControls
            currentIndex={currentIndex}
            currentSlide={currentSlide}
            totalItems={totalItems}
            handlePrevious={handlePrevious}
            handleNext={handleNext}
            setCurrentPage={setCurrentPage}
            itemsPerPage={itemsPerPage}
            itemsLength={FacultyStaffList.length}
          />
        </div>
      </div>

      {/* <FlipCard /> */}

      <div className="w-full h-[168px] md:hidden z-0">
        <Carousel
          additionalTransfrom={0}
          arrows
          // autoPlay
          // autoPlaySpeed={5000}
          centerMode={false}
          className="h-full"
          itemClass="h-full" // Ensure each item takes the full height
          containerClass="h-full"
          dotListClass=""
          draggable={false}
          focusOnSelect={false}
          infinite={true}
          keyBoardControl
          minimumTouchDrag={80}
          pauseOnHover={true}
          renderArrowsWhenDisabled={true}
          renderButtonGroupOutside={false}
          renderDotsOutside={false}
          responsive={{
            desktop: {
              breakpoint: {
                max: 3000,
                min: 1024,
              },
              items: 1,
              partialVisibilityGutter: 40,
            },
            mobile: {
              breakpoint: {
                max: 464,
                min: 0,
              },
              items: 1,
              partialVisibilityGutter: 30,
            },
            tablet: {
              breakpoint: {
                max: 1024,
                min: 464,
              },
              items: 1,
              partialVisibilityGutter: 30,
            },
          }}
          rewind
          rewindWithAnimation={false}
          rtl={false}
          shouldResetAutoplay
          showDots={false}
          sliderClass=""
          slidesToSlide={1}
          swipeable
        >
          {FacultyStaffList.map((item, index) => (
            <div key={index} className="w-full h-[168px] md:hidden relative">
              <img
                src={item.image}
                alt={item.image}
                className="w-full h-full object-cover object-center" // Ensure the image takes full height
              />{" "}
              <div
                className="w-full bg-[linear-gradient(90deg,_#000000_8%,_rgba(0,_0,_0,_0.4)_27.5%,_rgba(157,_156,_157,_0.05)_49%,_rgba(217,_217,_217,_0)_69%)]
            absolute bottom-0 left-0 text-white py-2 px-6 "
              >
                <span className="font-bold font-montserrat text-sm leading-6 tracking-[0.06em]">
                  {item.name}{" "}
                </span>{" "}
                <br />
                <span className=" font-medium font-montserrat text-xs leading-6 tracking-[0.06em]">
                  {item.position}{" "}
                </span>
              </div>
            </div>
          ))}
        </Carousel>{" "}
        {/* <IndicatorIcon /> */}
      </div>
    </section>
  );
}

export default FacultyStaff;
